import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Table from 'views/reports/registeredDocuments/recordTable'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record deposit reports view.
 * @extends JetView
 */
export default class recordDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerV', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        let id = ''; // Variable to store version ID
        this.on(this.app, 'version:id', (Id) => {
            // Event listener for version ID
            id = Id; // Assigning received ID to variable
        });
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying theme CSS
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            label: _('Versiones'), // Localized label text
                            align: 'center', // Center alignment
                        },
                        {
                            view: 'button', // Button to add a version
                            value: _('Añadir Versión'), // Localized button text
                            type: 'form', // Button type
                            width: 200, // Button width
                            click: () => {
                                // Click event handler
                                webix
                                    .ui({
                                        // Creating a new window UI
                                        view: 'window',
                                        width: 400,
                                        head: {
                                            view: 'toolbar', // Toolbar for the window header
                                            cols: [
                                                {
                                                    view: 'label', // Label for the window
                                                    label: _('Añadir Versión'), // Localized label text
                                                },
                                                {
                                                    view: 'icon', // Close icon for the window
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        // Click event to close the window
                                                        this.getTopParentView().hide(); // Hides the window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Center position of the window
                                        modal: true, // Modal window
                                        body: {
                                            view: 'form', // Form inside the window
                                            id: 'addVersion', // Unique identifier for the form
                                            elements: [
                                                {
                                                    view: 'text', // Text input for version
                                                    label: _('Versión'), // Localized label text
                                                    name: 'Version', // Input name
                                                    required: true, // Required field
                                                    labelWidth: 120, // Label width
                                                },
                                                {
                                                    view: 'text', // Text input for document URL
                                                    label: _('Url documento'), // Localized label text
                                                    name: 'DocumentUrl', // Input name
                                                    required: true, // Required field
                                                    labelWidth: 120, // Label width
                                                },
                                                {
                                                    view: 'text', // Text input for encryption value
                                                    label: _('Encriptación'), // Localized label text
                                                    name: 'EncryptionValue', // Input name
                                                    required: true, // Required field
                                                    labelWidth: 120, // Label width
                                                },
                                                {
                                                    cols: [
                                                        // Button layout
                                                        {
                                                            view: 'button', // Cancel button
                                                            value: _('Cancelar'), // Localized button text
                                                            click: function () {
                                                                // Click event to cancel
                                                                this.getTopParentView().hide(); // Hides the window
                                                                $$('addVersion').setValues(
                                                                    // Resets form values
                                                                    $$('addVersion').getCleanValues(),
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button
                                                            type: 'form', // Button type
                                                            value: _('Guardar'), // Localized button text
                                                            click: function ($e) {
                                                                // Click event to save
                                                                var values = $$('addVersion').getValues(); // Get form values
                                                                values.Id = id; // Assign version ID
                                                                if ($$('addVersion').validate()) {
                                                                    // Validate form
                                                                    webix
                                                                        .ajax() // AJAX request to save version
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() + // API URL from config
                                                                                'RegisteredDocument/AddVersion',
                                                                            values, // Data to send
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Error callback
                                                                                    webix.message('Error! '); // Show error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Success callback
                                                                                    var resp = JSON.parse(text); // Parse response
                                                                                    if (resp.HasError) {
                                                                                        // Check for errors in response
                                                                                        webix.message({
                                                                                            title: _('¡Error!'), // Localized error title
                                                                                            type: 'alert-error', // Error message type
                                                                                            text: _(
                                                                                                'Ocurrio un error, comuniquese con soporte',
                                                                                            ), // Localized error text
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Versión Agregada',
                                                                                        ); // Success message
                                                                                        $$('versionTable').clearAll(); // Clear version table
                                                                                        $$('versionTable').load(
                                                                                            // Reload version table
                                                                                            url +
                                                                                                '?start=0&count=' +
                                                                                                $$('versionTable').data
                                                                                                    .$pagesize,
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('addVersion').setValues(
                                                                        // Reset form values
                                                                        $$('addVersion').getCleanValues(),
                                                                    );
                                                                    this.getTopParentView().hide(); // Hides the window
                                                                } else {
                                                                    webix.message({
                                                                        // Show validation error message
                                                                        title: _('¡Error!'), // Localized error title
                                                                        type: 'alert-error', // Error message type
                                                                        text: _('Completa los campos...'), // Localized error text
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        // Change event for validation
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the window
                            },
                        },
                    ],
                },
                Table, // Including the Table component
                toolbar, // Including the toolbar
            ],
        };
        return {
            height: screen.width < 500 ? 350 : 0, // Set height based on screen width
            type: 'wide', // Layout type
            cols: [left], // Left column configuration
        };
    }
}

// FILE DOCUMENTED
